module.exports = __webpack_public_path__ + "static/img/年度最佳智能手表.ecaa5fbc.png";